import axios from 'axios';
import moment from 'moment';
import { Buffer } from 'buffer';
import { productTypeMapping } from './productTypeMapping';
import { productMapping } from './productMapping';
import { createSourceInformation, formatSSNToNumbers } from './formServiceUtils';
import { commonTernary, nameProduct } from '../components/commonCode';
import { ELITE_ACCOUNT_EN, ELITE_ACCOUNT_ES, LIBRE_AHORRA_BUNDLE } from '../constants';

export const globalHeaders = {
  Authorization: (token) => `Bearer ${token}`,
  sessionid: (sessionid) => sessionid,
  // logicalresourceid: 'SelfServicePortal',
  // scope: 'Low',
  // channel: 'portal',
  'x-api-key': process.env.REACT_APP_AUTH_API_KEY,
  appid: 'sales',
  source: 'sales',
};
export const authenticateAccountWithSSN = async (ssn, dateOfBirth, language, uuid) => {
  let response = null;
  try {
    response = await axios.post(
      process.env.REACT_APP_EXPRESS_FLOW_USERNAME,
      {
        dob: dateOfBirth,
        taxId: ssn,
      },
      {
        headers: {
          'x-api-key': process.env.REACT_APP_AUTH_API_KEY,
          appid: 'sales',
          language: language === 'EN' ? 'EN' : 'ES',
          uuid,
          source: 'sales',
        },
      }
    );
  } catch (e) {
    return e.response;
  }
  return response;
};

export const submitGenerateOtpRequest = async (
  data,
  txnId,
  token,
  language,
  uuid,
  customerGuid,
  sessionId
) => {
  let response = null;
  let deliveryMethod = '';
  if (data.prefferedOption === 'email') {
    deliveryMethod = 'EMAIL';
  } else if (data.prefferedOption === 'phoneCall') {
    deliveryMethod = 'IVR';
  } else {
    deliveryMethod = 'SMS';
  }
  // 'https://api-dt-dev.orientalbank.com/ob-idmapi/light/authentication/SSP/otpDelivery'
  try {
    response = await axios.post(
      process.env.REACT_APP_EXPRESS_FLOW_OTPCHOICE,
      {
        txnId,
        deviceId: data.deviceId,

        deliveryMedium: deliveryMethod === 'EMAIL' ? deliveryMethod : '',
        guuid: customerGuid,
        source: 'sales',
      },
      // {
      //   headers: {
      //     Authorization: `Bearer ${token}`,
      //     logicalresourceid: 'SelfServicePortal',
      //     scope: 'Low',
      //     channel: 'portal',
      //   },
      // }
      {
        headers: {
          ...globalHeaders,
          Authorization: globalHeaders.Authorization(token),
          sessionid: globalHeaders.sessionid(sessionId),
          language: language === 'EN' ? 'EN' : 'ES',
          uuid,
          // sessionid: '51355341250463721062',
        },
      }
    );
  } catch (e) {
    return e.response;
  }
  return response;
};

export const submitVerifyOtpRequest = async (
  otpValue,
  token,
  txnId,
  language,
  uuid,
  customerGuid,
  contactInfoDetails
) => {
  let response = null;
  // 'https://api-dt-dev.orientalbank.com/ob-idmapi/light/authentication/SSP/otpVerify'
  try {
    response = await axios.post(
      process.env.REACT_APP_EXPRESS_FLOW_PASSWORD,
      {
        txnId,
        otp: otpValue,
        // lang: language === 'EN' ? 'ENG' : 'ESP',
        // uuid,
        // guuid: customerGuid,
        // source: 'sales',
      },
      {
        headers: {
          ...globalHeaders,
          Authorization: globalHeaders.Authorization(token),
          sessionid: globalHeaders.sessionid(contactInfoDetails?.sessionId),
          language: language === 'EN' ? 'EN' : 'ES',
          uuid,
        },
      }
    );
  } catch (e) {
    return e.response;
  }
  return response;
};

export const RegenerateOtpRequest = async (txnId, token, language, customerGuid, uuid) => {
  let response = null;
  // 'https://api-dt-dev.orientalbank.com/ob-idmapi/light/authentication/SSP/otpResend'
  try {
    response = await axios.post(
      process.env.REACT_APP_REGENERATE_OTP_API,
      {
        txnId,
        // guuid: customerGuid,
        // lang: language === 'EN' ? 'en' : 'es',
        // uuid,
        // source: 'sales',
      },
      {
        headers: {
          ...globalHeaders,
          Authorization: globalHeaders.Authorization(token),
          language: language === 'EN' ? 'EN' : 'ES',
          uuid,
        },
      }
    );
  } catch (e) {
    return e.response;
  }
  return response;
};
// export const getOtpAccessToken = async () => {
//   let token = null;
//   const base64Authorization = Buffer.from(
//     `65de37cpr9j56tq6ul8drpf45f:1f3hvqbuiahkoanu5uum9l2i3kuqknf0mr9gq1di05in27psb5hm`
//   ).toString('base64');
//   const tokenResponse = await axios.post(
//     process.env.REACT_APP_DCSSP_PEGA_SSP_AUTH_TOKEN,
//     { clientId: process.env.REACT_APP_CLIENT_ID_CHATBOT },
//     {
//       headers: {
//         Authorization: `Basic ${base64Authorization}`,
//         'Content-Type': 'application/x-www-form-urlencoded',
//       },
//     }
//   );
//   if (tokenResponse?.data) {
//     token = tokenResponse.data.access_token;
//   }
//   return token;
// };

export const saveOtpAddressScreen = async (token, addressObj, data) => {
  let response = null;
  const formData = {
    Event: 'CaptureExpressContactInfo',
    Application: {
      ApplicationID: data?.customerAppId,
      TemplateVersion: '2021-08-05',
      Source: {
        Language: data?.language,
        Location: data?.location,
      },
      Products: [
        {
          ProductType: productTypeMapping(data?.productType),
          ProductName: productMapping(data?.productName),
          Category: 'Primary',
        },
        ...(data?.productName === 'Elite Account' || data?.productName === LIBRE_AHORRA_BUNDLE
          ? [
              {
                ProductType:
                  data?.productName === 'Elite Account' || data?.productName === LIBRE_AHORRA_BUNDLE
                    ? 'Savings Account'
                    : productTypeMapping(data?.productType),
                ProductName: productMapping(data?.productName),
                Category: 'Secondary',
              },
            ]
          : []),
      ],
      Applicants: [
        {
          Contacts: [
            {
              ContactType: 'email',
              ContactValue: data?.email,
              Validation: {
                ValidatedBy: data?.emailVerificationResponse
                  ? data?.emailVerificationResponse?.validatedBy
                  : null,
                Status: data?.emailVerificationResponse
                  ? data?.emailVerificationResponse?.status
                  : null,
                ResultCodes: data?.emailVerificationResponse
                  ? data?.emailVerificationResponse.resultCode
                  : null,
                Message: data?.emailVerificationResponse
                  ? data?.emailVerificationResponse.message
                  : null,
                Timestamp: data?.emailVerificationResponse
                  ? data?.emailVerificationResponse.timestamp
                  : null,
              },
            },
            {
              ContactType: 'mobile',
              ContactValue:
                data?.location !== 'VI' ? `(${data?.areaCode}) ${data?.phone}` : data?.phone,
              // PrefferedContactTime: null,
              Validation: {
                ValidatedBy: data?.phoneValidationResponse
                  ? data?.phoneValidationResponse?.validatedBy
                  : null,
                Status: data?.phoneValidationResponse ? data?.phoneValidationResponse.status : null,
                ResultCodes: data?.phoneValidationResponse
                  ? data?.phoneValidationResponse.resultCodes
                  : null,
                Message: data?.phoneValidationResponse
                  ? data?.phoneValidationResponse.message
                  : null,
                Timestamp: data?.phoneValidationResponse
                  ? data?.phoneValidationResponse.timestamp
                  : null,
              },
            },
          ],
          Addresses: [
            {
              AddrType: 'mailing',
              LineOne: addressObj.line1,
              LineTwo: addressObj.line2,
              AddrCity: addressObj.city,
              AddrState: addressObj.state,
              AddrCountry: addressObj.country,
              ZipCode: addressObj.zipcode,
            },
          ],
        },
      ],
      Processing: {
        CaseReference: [],
      },
    },
  };
  try {
    response = await axios.post(process.env.REACT_APP_SAVE_SUBMIT_APPLICATION_URL, formData, {
      headers: {
        appid: 'sales',
        'Application-Id': data?.customerAppId,
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json; charset=UTF-8',
      },
    });
  } catch (e) {
    return e.response;
  }
  return response;
};

export const expressPreAuthentication = async (data, state, eventName) => {
  const formattedDate = moment(state?.dob).format('yyyy-MM-DD');
  const formData = {
    Event: eventName,
    Application: {
      TemplateVersion: '2024-08-14',
      Source: createSourceInformation(data),
      ApplicationID: data.applicationId,
      ApplicationFlow: 'ExpressPreAuthentication',
      Products: [
        {
          ProductType: productTypeMapping(data.productType),
          ProductName: nameProduct(data),
          Category: 'Primary',
        },
        ...(data.productName === ELITE_ACCOUNT_EN ||
        data.productName === ELITE_ACCOUNT_ES ||
        data.productName === LIBRE_AHORRA_BUNDLE
          ? [
              {
                ProductType:
                  data.productName === ELITE_ACCOUNT_EN ||
                  data.productName === ELITE_ACCOUNT_ES ||
                  data.productName === LIBRE_AHORRA_BUNDLE
                    ? 'Savings Account'
                    : productTypeMapping(data.productType),
                ProductName: nameProduct(data),
                Category: 'Secondary',
              },
            ]
          : []),
      ].filter(Boolean),
      Applicants: [
        {
          ApplicantCategory: 'Primary',
          Identifications: [
            {
              IdenDOB: formattedDate,
            },
          ],
          CustTaxId: formatSSNToNumbers(state?.ssnId || state?.ssn),
        },
      ],
      Processing: { CaseReference: [] },
    },
  };
  let result = null;
  try {
    result = await axios.post(process.env.REACT_APP_SAVE_SUBMIT_APPLICATION_URL, formData, {
      headers: {
        appid: 'sales',
        Authorization: `Bearer ${data?.accessToken}`,
        'Content-Type': 'application/json; charset=UTF-8',
      },
    });
  } catch (errors) {
    return errors.response;
  }
  return result;
};
